<rv-badge [color]="badgeColor" [icon]="badgeIcon" [text]="scheduleTypeName" />
